import React, { useRef, useContext, useState, useEffect, useCallback } from "react";
import { ArrowLeft, Plus, Pencil, Printer, Trash2 } from "lucide-react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import LogicContext from "../../Context/LogicContext";
import { GetPaymentMadeAtom, SetPaymentEdit } from "../../store/paymentMadeAtom";
import { Dropdown } from 'react-bootstrap';
import PaymentMadeScroll from "./PaymentmadeScroll";
import { paymentMadeService } from "../../services/paymentMade";
import { formatCustomDate, formatCustomDateWithoutTime } from "../../helpers/formatCustomDate";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { SetPaymentMadeAtom } from "../../store/paymentReceivedAtom";
import StatusBadge from "../../generals/StatusBadge";


const Field = ({ label, children, className = "" }) => (
  <div className={className}>
    <p className="text-sm text-gray-500">{label}</p>
    <div className="mt-0.5 text-sm font-semibold text-gray-800">
      {children || "—"}
    </div>
  </div>
);


const PaymentMadeDetailsPage = () => {
  const [selectedList, setSelectedList] = useState([]);
  const myPromiseModal = createModal(GeneralModal);
  const setPaymentEdit = SetPaymentEdit();
    const setPaymentMadeAtom  = SetPaymentMadeAtom();
    const getPaymentMadeAtom  = GetPaymentMadeAtom();

  const { id } = useParams();
  const navigate = useNavigate();
  const logicContext = useContext(LogicContext);
  const [paymentDetails, setPaymentDetails] = useState({ bill_info:[], payment_info:[]});

  

  const { pathname } = useLocation();
  const printRef = useRef(null);

  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    document.title = "Payment Made Details";
    let isMounted = true;

    if (isMounted) {
      loadDetailsData();
    }

    return () => {
      isMounted = false;
    };
  }, [id]);


  const loadDetailsData = () => {
    paymentMadeService.paymentMadeDetails(id).then((response) => {
      const serverData = response.data;
      if (serverData) {
        setPaymentDetails(serverData);
      }
    });
  }



   useEffect(() => {
      if (getPaymentMadeAtom?.payment_info?.length > 0) {
      }else{
        getPaymentMadeFromAPI();
      }
      return () => {
      };
    }, [getPaymentMadeAtom]);



  const editCurrentData = async () => {
    const response = await myPromiseModal({
      title: "Modify Adjustment",
      body: "Do you want to modify this record?",
      showInput: false,
    });

    if (response.decision === true) {
      setPaymentEdit(paymentDetails);
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    }
  };

  const newPayment = async () => {
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    
  };


  const viewVendor = (vendorId) => {
    console.log('vendorid ', vendorId);
    const customerRoute = `/${currModuleId}/${currModuleName}/vendors/details/${vendorId}`;
    window.open(customerRoute, '_blank');

  }

  const viewBill = (billId) => {
    const customerRoute = `/${currModuleId}/${currModuleName}/bills/details/${billId}`;
    window.open(customerRoute, '_blank');

  }


   async function bulkActionsSingle(action) {
    const option = action.action_option;
     const result =  await myPromiseModal({
        title: 'confirm your action!',
        body: `Do you want to ${action.status_name} ?`,
        showInput: false,
        placeHolder: '',
      });
      if(result.decision === false){
        return;
      }

      

      try {
        const payload = {option:option, payment_ref_no:id}
        const res = await paymentMadeService.paymentMadeAction(payload);
        const response = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);

        if (response.message_id === 1) {
          logicContext.showToast(response.message_text || 'Stock adjustment saved successfully!', 'success');
          loadDetailsData();
        } else {
          logicContext.showToast(response.message_text || 'Failed to save', 'error');
        }
        
        
      } catch (error) {
       console.log("error", error);


 
      }
    
      
   
     
    }
  


    


  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Payment Made _${paymentDetails?.payment_info?.[0]?.payment_ref_no}`,
    onAfterPrint: () => console.log("Printed successfully"),
  });

  const onSelection = (list) => {
    const tempList = list?.filter((item) => item.checked === true);
    setSelectedList(tempList);
  };

    const viewItemDetails = useCallback(
      adId => {
        navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${adId}`);
      },
      [currModuleId, currModuleName, navigate]
    );


      const getPaymentMadeFromAPI = useCallback(async () => {
       
        try {
          const response = await paymentMadeService.paymentMadeList();
          const serverData =  response.data;
          if ( response?.data !== undefined) {
    
            
            const payment_info = serverData?.payment_info?.length ?  serverData?.payment_info : [];
            const pay_List = serverData?.payment_through?.length ?  serverData?.payment_through : [];
            const vendor = serverData?.vendor?.length ?  serverData?.vendor : [];
            const tax_info = serverData?.vendor?.length ?  serverData?.tax_info : [];
            setPaymentMadeAtom({...serverData, payment_through: pay_List, vendor:vendor, payment_info: payment_info, tax_info:tax_info });
    
          }
        } catch (err) {
            console.error(err);
        }
       
      }, [setPaymentMadeAtom]);

      

  const info = paymentDetails?.payment_info?.[0];
  const bills = paymentDetails?.bill_info || [];
  const sumBills = (field) =>
    bills.reduce((sum, item) => sum + (Number(item?.[field]) || 0), 0);
  const iconBtn =
    "flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-800";

  return (
    <section className="mt-2 px-3 pb-12">
      <div className="mx-auto max-w-7xl">
        {/* Toolbar */}
        <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
          <div className="flex min-w-0 items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className={iconBtn}
              aria-label="Go back"
            >
              <ArrowLeft className="h-5 w-5" />
            </button>
            <div className="min-w-0">
              <h1 className="truncate text-xl font-semibold text-gray-800">
                {info?.payment_number || "Payment details"}
              </h1>
              <p className="truncate text-sm text-gray-500">
                Payment made · Ref {info?.payment_ref_no || "—"}
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            {paymentDetails?.action_status?.length > 0 && (
              <Dropdown>
                <Dropdown.Toggle
                  className="rounded-lg border-0 bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700"
                  id="dropdown-basic"
                >
                  Action
                </Dropdown.Toggle>
                <Dropdown.Menu className="mt-2 rounded-md border border-gray-200 bg-white shadow-lg">
                  {paymentDetails?.action_status?.map((option, i) => (
                    <Dropdown.Item
                      key={i}
                      onClick={() => bulkActionsSingle(option)}
                      className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      {option?.status_name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            )}

            <button
              onClick={newPayment}
              className="inline-flex items-center gap-1.5 rounded-lg bg-blue-600 px-3 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700"
            >
              <Plus className="h-4 w-4" /> New
            </button>
            <button onClick={editCurrentData} className={iconBtn} title="Edit">
              <Pencil className="h-4 w-4" />
            </button>
            <button onClick={handlePrint} className={iconBtn} title="Print">
              <Printer className="h-4 w-4" />
            </button>
            <button
              disabled
              className={`${iconBtn} cursor-not-allowed opacity-40`}
              title="Delete (not available yet)"
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        </div>

        <div className="flex flex-col gap-6 lg:flex-row">
          {/* Left sidebar - scroll list */}
          <div className="w-full shrink-0 lg:w-72">
            <PaymentMadeScroll onSelection={onSelection} viewItemDetails={viewItemDetails} />
          </div>

          {/* Main details card - PRINTABLE AREA */}
          <div
            ref={printRef}
            className="flex-1 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm"
          >
            <div className="p-6 lg:p-8">
              {/* Header */}
              <div className="mb-6 flex flex-col gap-3 border-b border-gray-100 pb-5 sm:flex-row sm:items-start sm:justify-between">
                <div>
                  <p className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                    Payment made
                  </p>
                  <h2 className="mt-1 text-2xl font-bold text-gray-800">
                    {info?.payment_number || "—"}
                  </h2>
                  <p className="mt-1 text-sm text-gray-500">
                    Ref: {info?.payment_ref_no || "—"}
                  </p>
                </div>
                <StatusBadge
                  statusId={info?.payment_status_id}
                  statusName={info?.payment_status_name}
                  size="md"
                />
              </div>

              {/* Amount summary */}
              <div className="mb-8 grid grid-cols-1 gap-3 sm:grid-cols-3">
                <div className="rounded-lg border border-gray-100 bg-gray-50 p-4">
                  <p className="text-xs font-medium uppercase tracking-wide text-gray-500">
                    Payment amount
                  </p>
                  <p className="mt-1 text-xl font-bold tabular-nums text-gray-800">
                    {formatCustomNumber(info?.total_payment_amount) || "—"}
                  </p>
                </div>
                <div className="rounded-lg border border-gray-100 bg-gray-50 p-4">
                  <p className="text-xs font-medium uppercase tracking-wide text-gray-500">
                    Excess amount
                  </p>
                  <p className="mt-1 text-xl font-bold tabular-nums text-red-600">
                    {formatCustomNumber(info?.excess_amount) || "—"}
                  </p>
                </div>
                <div className="rounded-lg border border-gray-100 bg-gray-50 p-4">
                  <p className="text-xs font-medium uppercase tracking-wide text-gray-500">
                    Total incl. excess
                  </p>
                  <p className="mt-1 text-xl font-bold tabular-nums text-green-600">
                    {formatCustomNumber(info?.total_payment_with_excess_amount) || "—"}
                  </p>
                </div>
              </div>

              {/* Details sections */}
              <div className="mb-8 space-y-7">
                <div>
                  <h3 className="mb-3 text-xs font-semibold uppercase tracking-wider text-gray-400">
                    Payment
                  </h3>
                  <div className="grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2 lg:grid-cols-4">
                    <Field label="Payment No">{info?.payment_number}</Field>
                    <Field label="Payment Date">
                      {formatCustomDate(info?.payment_date)}
                    </Field>
                    <Field label="Reference">{info?.reference_number}</Field>
                    <Field label="TDS">{info?.tds_name}</Field>
                  </div>
                </div>

                <div>
                  <h3 className="mb-3 text-xs font-semibold uppercase tracking-wider text-gray-400">
                    Vendor
                  </h3>
                  <div className="grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2 lg:grid-cols-4">
                    <Field label="Vendor">
                      {info?.vendor_name && (
                        <button
                          onClick={() => viewVendor(info?.vendor_id)}
                          className="font-semibold text-blue-600 hover:text-blue-700 hover:underline"
                        >
                          {info?.vendor_name}
                        </button>
                      )}
                    </Field>
                    <Field label="Phone">{info?.vendor_mobile_number}</Field>
                    <Field label="Address" className="sm:col-span-2">
                      {info?.vendor_address}
                    </Field>
                  </div>
                </div>

                <div>
                  <h3 className="mb-3 text-xs font-semibold uppercase tracking-wider text-gray-400">
                    Record
                  </h3>
                  <div className="grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2 lg:grid-cols-4">
                    <Field label="Created By">{info?.created_user_full_name}</Field>
                    <Field label="Created Date">{info?.created_date_string}</Field>
                    <Field label="Approved By">{info?.approved_by_name}</Field>
                    <Field label="Approved Date">{info?.approved_date}</Field>
                  </div>
                </div>
              </div>

              {/* Bills table */}
              <div>
                <div className="mb-3 flex items-center justify-between">
                  <h3 className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                    Bills paid
                  </h3>
                  <span className="text-xs text-gray-400">
                    {bills.length} {bills.length === 1 ? "bill" : "bills"}
                  </span>
                </div>
                <div className="overflow-x-auto rounded-lg border border-gray-200">
                  <table className="w-full text-sm">
                    <thead className="bg-gray-50 text-xs uppercase tracking-wide text-gray-500">
                      <tr>
                        <th className="px-4 py-3 text-left font-semibold">Bill No.</th>
                        <th className="px-4 py-3 text-left font-semibold">Bill Date</th>
                        <th className="px-4 py-3 text-right font-semibold">Bill Amount</th>
                        <th className="px-4 py-3 text-right font-semibold">Payment</th>
                        <th className="px-4 py-3 text-right font-semibold">Previous Payments</th>
                        <th className="px-4 py-3 text-right font-semibold">Balance</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {bills.length > 0 ? (
                        bills.map((item) => (
                          <tr key={item.bill_ref_no} className="hover:bg-gray-50">
                            <td className="px-4 py-3">
                              <button
                                onClick={() => viewBill(item?.bill_ref_no)}
                                className="font-semibold text-blue-600 hover:text-blue-700 hover:underline"
                              >
                                {item.bill_number}
                              </button>
                            </td>
                            <td className="px-4 py-3 text-gray-600">
                              {formatCustomDateWithoutTime(item.bill_date)}
                            </td>
                            <td className="px-4 py-3 text-right tabular-nums text-gray-600">
                              {formatCustomNumber(item.bill_amount)}
                            </td>
                            <td className="px-4 py-3 text-right tabular-nums text-gray-600">
                              {formatCustomNumber(item.payment_amount)}
                            </td>
                            <td className="px-4 py-3 text-right tabular-nums text-gray-600">
                              {formatCustomNumber(item.previous_payment_amount)}
                            </td>
                            <td className="px-4 py-3 text-right font-semibold tabular-nums text-gray-800">
                              {formatCustomNumber(item.remaining_amount)}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="py-8 text-center text-gray-500">
                            No bills linked to this payment.
                          </td>
                        </tr>
                      )}
                    </tbody>
                    {bills.length > 0 && (
                      <tfoot className="border-t border-gray-200 bg-gray-50 text-sm font-semibold text-gray-800">
                        <tr>
                          <td className="px-4 py-3" colSpan={2}>
                            Total
                          </td>
                          <td className="px-4 py-3 text-right tabular-nums">
                            {formatCustomNumber(sumBills("bill_amount"))}
                          </td>
                          <td className="px-4 py-3 text-right tabular-nums">
                            {formatCustomNumber(sumBills("payment_amount"))}
                          </td>
                          <td className="px-4 py-3 text-right tabular-nums">
                            {formatCustomNumber(sumBills("previous_payment_amount"))}
                          </td>
                          <td className="px-4 py-3 text-right tabular-nums">
                            {formatCustomNumber(sumBills("remaining_amount"))}
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentMadeDetailsPage;